import * as React from "react";

function SvgFull(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}><path d="M0 0v16h16V0H0zm13 13H3V3h10v10z" fill="#555d63" /></svg>;
}

export default SvgFull;